import { fetcher } from "@website/fetcher/fetcher";
import {
  AuthVerifyOtpBodyType,
  AuthVerifyOtpResponseType
} from "@website/widget/login/services/auth-b2b-verify-otp/auth-b2b-verify-otp.types";

export const AuthVerifyOtpUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/b2b/auth/otp`;

export const AuthB2BVerifyOtpService = (
  data: AuthVerifyOtpBodyType
): Promise<AuthVerifyOtpResponseType> =>
  fetcher({
    url: AuthVerifyOtpUrl,
    method: "POST",
    data: { ...data }
  }).then(({ data }) => data);
